
import { types, actions } from './requests'
export const GETVARIANT_TYPES = {
    ...types('GETVARIANT'),
}
export const GETVARIANT_ACTIONS = {
    ...actions('GETVARIANT'),
}